const PERMISSION_KEY= "company:gold_exchange";
const PAGE_URL = {
    GOLD_EXCHANGE_PAGE: "/admin/company/gold-exchange"
}

export {PERMISSION_KEY, PAGE_URL}

